// @/component/ 目录下的文件自动挂载为组件
import Vue from 'vue'

const moduleList = require.context('@/component', false, /\.vue$/)
moduleList.keys().forEach((fileName) => {
  const moduleName = 'bm-' + fileName.substring(2, fileName.length - 4)
  Vue.component(moduleName, moduleList(fileName).default)
})
